import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./PartnerBooking.module.css";
import PartnerNavSlider from '../NavSlider/PartnerNavSlider';


/* =========================================================
   BOOKING DATA
========================================================= */

const bookingData = [


    {
        id: 3,
        name: "Priya Verma",
        category: "Home Cook",
        avatar:
            "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80",
        date: "Work completed on sun, feb 10",
        duration: "Recurring Service - Monthly",
        location: "Manewada, Nagpur",
        status: "Done",
    },
];


/* =========================================================
   PartnerBooking COMPONENT
========================================================= */

export default function PartnerBooking() {
    const navigate = useNavigate();

    const { userId, deviceUuid } = useParams();

    const basePath =
        userId && deviceUuid
            ? `/${userId}/${deviceUuid}`
            : "";

    /* =======================================================
       BOOKING TABS
    ======================================================= */

    const [activeTab, setActiveTab] = useState("Done");


    /* =======================================================
       BOTTOM NAVIGATION
    ======================================================= */

    const [activeNav, setActiveNav] = useState("clipboard");


    /* =======================================================
       FILTER BOOKINGS
    ======================================================= */

    const filteredBookings = bookingData.filter((item) => {
        if (activeTab === "Float") {
            return item.status === "Float";
        }

        if (activeTab === "Done") {
            return item.status === "Done";
        }

        return item.status === "In Progress";
    });


    /* =======================================================
       FLOAT COUNT
    ======================================================= */

    const floatCount = bookingData.filter(
        (item) => item.status === "Float"
    ).length;


    /* =======================================================
       BOTTOM NAVIGATION HANDLER
    ======================================================= */

    const handleNavigation = (tab, path) => {
        setActiveNav(tab);

        if (basePath) {
            navigate(`${basePath}${path}`);
        } else {
            navigate(path);
        }
    };

    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenu = () => {
        setMenuOpen(true);
    };


    /* =======================================================
       RENDER
    ======================================================= */

    return (
        <div className={styles.bookingPageWrapper}>

            {/* =====================================================
                                NAV SLIDER
                            ====================================================== */}

            <PartnerNavSlider
                isOpen={menuOpen}
                onClose={() => setMenuOpen(false)}
                navigate={navigate}
            />

            <div className={styles.bookingDeviceCard}>

                {/* =================================================
            HEADER
        ================================================= */}

                <header className={styles.bookingHeader}>

                    <h1 className={styles.headerTitle}>
                        My Bookings
                    </h1>

                    <button
                        className={styles.menuHamburgerBtn}
                        aria-label="Open Menu"
                        type="button"
                        onClick={handleMenu}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#0066cc"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        >
                            <line
                                x1="3"
                                y1="6"
                                x2="21"
                                y2="6"
                            />

                            <line
                                x1="3"
                                y1="12"
                                x2="21"
                                y2="12"
                            />

                            <line
                                x1="3"
                                y1="18"
                                x2="21"
                                y2="18"
                            />
                        </svg>
                    </button>

                </header>


                {/* =================================================
            BOOKING TABS
        ================================================= */}

                <nav className={styles.tabsNavigation}>

                    {/* IN PROGRESS */}

                    <button
                        type="button"
                        className={`${styles.tabBtn} ${activeTab === "In Progress"
                            ? styles.active
                            : ""
                            }`}
                        onClick={() =>
                            setActiveTab("In Progress")
                        }
                    >
                        In Progress
                    </button>


                    {/* DONE */}

                    <button
                        type="button"
                        className={`${styles.tabBtn} ${activeTab === "Done"
                            ? styles.active
                            : ""
                            }`}
                        onClick={() =>
                            setActiveTab("Done")
                        }
                    >
                        Done
                    </button>


                    {/* FLOAT */}

                    <button
                        type="button"
                        className={`${styles.tabBtn} ${activeTab === "Float"
                            ? styles.active
                            : ""
                            }`}
                        onClick={() =>
                            setActiveTab("Float")
                        }
                    >
                        <span>Float</span>

                        {floatCount > 0 && (
                            <span className={styles.tabBadge}>
                                {floatCount}
                            </span>
                        )}
                    </button>

                </nav>


                {/* =================================================
            BOOKING LIST
        ================================================= */}

                <main className={styles.bookingScrollBody}>

                    {filteredBookings.length === 0 ? (

                        <div className={styles.emptyState}>

                            <div>
                                <style>{`
        /* Outer Canvas Container */
        .emptyState {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
}

.my-bookings-screen-wrapper {
  min-height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.my-bookings-device-frame {
  width: 100%;
  max-width: 410px;
  min-height: 520px;
  height: auto;
  max-height: calc(100vh - 40px);
  overflow: hidden;
  position: relative;
}

.my-bookings-scroll-container {
  width: 100%;
  min-height: 520px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.my-bookings-content {
  width: 100%;
  max-width: 340px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
}

.my-bookings-title {
  margin: 0 0 12px;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 800;
}

.my-bookings-subtitle {
  margin: 0 0 30px;
  font-size: 17px;
  line-height: 1.5;
  font-weight: 400;
}

.my-bookings-btn-wrapper {
  display: inline-flex;
  padding: 3px;
  border-radius: 14px;
}

.my-bookings-btn {
  min-width: 180px;
  height: 52px;
  padding: 0 28px;
  border: 0;
  border-radius: 11px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease,
    box-shadow 0.2s ease;
}

.my-bookings-btn:hover {
  transform: translateY(-1px);
}

.my-bookings-btn:active {
  transform: scale(0.97);
}

.my-bookings-btn:focus-visible {
  outline: 3px solid rgba(0, 92, 169, 0.25);
  outline-offset: 3px;
}

/* Mobile */
@media (max-width: 480px) {
  .my-bookings-screen-wrapper {
    min-height: 100dvh;
    padding: 0;
  }

  .my-bookings-device-frame {
    width: 100%;
    max-width: 100%;
    min-height: 100dvh;
    max-height: none;
    border-radius: 0;
    box-shadow: none;
  }

  .my-bookings-scroll-container {
    width: 100%;
    min-height: calc(70dvh - 80px);
    max-height: none;
    padding: 32px 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
  }

  .my-bookings-content {
    max-width: 320px;
  }

  .my-bookings-title {
    font-size: 24px;
  }

  .my-bookings-subtitle {
    font-size: 16px;
    margin-bottom: 26px;
  }

  .my-bookings-btn {
    width: 100%;
    min-width: 0;
    height: 50px;
    font-size: 16px;
  }
}

/* Tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .my-bookings-device-frame {
    max-width: 440px;
  }
}

/* Desktop */
@media (min-width: 1025px) {
  .my-bookings-device-frame {
    max-width: 420px;
  }
}
      `}</style>

                                <div className="my-bookings-screen-wrapper">
                                    <div className="my-bookings-device-frame">
                                        <div className="my-bookings-scroll-container">
                                            <main className="my-bookings-content">

                                                {/* Empty State Title */}
                                                <h1 className="my-bookings-title">
                                                    You don’t have any orders yet.
                                                </h1>

                                                {/* Empty State Description */}
                                                <p className="my-bookings-subtitle">
                                                    When you do, you can find them here.
                                                </p>

                                                {/* Action Button */}
                                                <div className="my-bookings-btn-wrapper">
                                                    <button
                                                        type="button"
                                                        className="my-bookings-btn"
                                                    // onClick={onBookService}
                                                    >
                                                        Book a service
                                                    </button>
                                                </div>

                                            </main>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    ) : (

                        filteredBookings.map((item) => (

                            <div
                                key={item.id}
                                className={styles.bookingCard}
                            >

                                {/* =========================================
                    CARD TOP
                ========================================= */}

                                <div className={styles.bookingCardTop}>

                                    {/* USER */}

                                    <div className={styles.userProfileMeta}>

                                        <img
                                            src={item.avatar}
                                            alt={item.name}
                                            className={styles.userAvatar}
                                        />

                                        <div className={styles.userInfo}>

                                            {/* NAME + CATEGORY */}

                                            <div className={styles.nameCategoryRow}>

                                                <h3 className={styles.userName}>
                                                    {item.name}
                                                </h3>

                                                <span className={styles.categoryTag}>
                                                    {item.category}
                                                </span>

                                            </div>


                                            {/* META INFORMATION */}

                                            <div className={styles.metaList}>

                                                {/* DATE */}

                                                <div className={styles.metaItem}>

                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#0066cc"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <rect
                                                            x="3"
                                                            y="4"
                                                            width="18"
                                                            height="18"
                                                            rx="2"
                                                            ry="2"
                                                        />

                                                        <line
                                                            x1="16"
                                                            y1="2"
                                                            x2="16"
                                                            y2="6"
                                                        />

                                                        <line
                                                            x1="8"
                                                            y1="2"
                                                            x2="8"
                                                            y2="6"
                                                        />

                                                        <line
                                                            x1="3"
                                                            y1="10"
                                                            x2="21"
                                                            y2="10"
                                                        />
                                                    </svg>

                                                    <span>
                                                        {item.date}
                                                    </span>

                                                </div>


                                                {/* DURATION */}

                                                <div className={styles.metaItem}>

                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#0066cc"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <circle
                                                            cx="12"
                                                            cy="12"
                                                            r="10"
                                                        />

                                                        <polyline
                                                            points="12 6 12 12 16 14"
                                                        />
                                                    </svg>

                                                    <span>
                                                        {item.duration}
                                                    </span>

                                                </div>


                                                {/* LOCATION */}

                                                <div className={styles.metaItem}>

                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#0066cc"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path
                                                            d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                                                        />

                                                        <circle
                                                            cx="12"
                                                            cy="10"
                                                            r="3"
                                                        />
                                                    </svg>

                                                    <span>
                                                        {item.location}
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>


                                    {/* CHEVRON */}

                                    <button
                                        className={styles.chevronBtn}
                                        aria-label="View Info"
                                        type="button"
                                    >
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0066cc"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                    </button>

                                </div>


                                {/* =========================================
                    CARD ACTIONS
                ========================================= */}

                                <div className={styles.bookingCardActions}>

                                    <button
                                        type="button"
                                        className={`${styles.actionBtn} ${styles.btnCancel}`}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className={`${styles.actionBtn} ${styles.btnPrimary}`}
                                    >
                                        Float Details
                                    </button>

                                </div>

                            </div>

                        ))

                    )}

                </main>


                

                {/* =================================================
            BOTTOM NAVIGATION
        ================================================= */}

                <div className={styles.bottomNavWrapper}>

                    <nav
                        className={styles.bottomNav}
                        aria-label="Bottom Navigation"
                    >

                        {/* =============================================
                               HOME
                                 ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "home"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "home",
                                    "/partnerhome"
                                )
                            }
                            aria-label="Home"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <path
                                    d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9"
                                />

                                <polyline
                                    points="9 22 9 12 15 12 15 22"
                                />

                            </svg>

                            <span className={styles.navLabel}>
                                Home
                            </span>

                        </button>


                        {/* =============================================
                              T ASKS
                             ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "clipboard"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "clipboard",
                                    "/partner_booking"
                                )
                            }
                            aria-label="Tasks"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <path
                                    d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                                />

                                <rect
                                    x="8"
                                    y="2"
                                    width="8"
                                    height="4"
                                    rx="1"
                                />

                                <path d="M8 11h8" />

                                <path d="M8 15h5" />

                            </svg>

                            <span className={styles.navLabel}>
                                Tasks
                            </span>

                        </button>


                        {/* =============================================
                              WALLET
                          ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "wallet"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "wallet",
                                    "/partner_wallet"
                                )
                            }
                            aria-label="Wallet"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <rect
                                    x="2"
                                    y="6"
                                    width="20"
                                    height="12"
                                    rx="3"
                                />

                                <path d="M18 12h.01" />

                            </svg>

                            <span className={styles.navLabel}>
                                Wallet
                            </span>

                        </button>

                    </nav>

                </div>



            </div>

        </div>
    );
}